// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"296":"e0820f6d","473":"95deefb0"}[chunkId] + ".chunk.js";
};